module.exports = __webpack_public_path__ + "assets/img/6ec3b369bf650a593b95ff6f0194426b.png";